import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
// import html2canvas from 'html2canvas';
import errorBoundary from '@ifeng/errorBoundary';

class Haibao extends React.PureComponent {
    static propTypes = {
        bref: PropTypes.string,
        tip: PropTypes.string,
        allList: PropTypes.array,
    };

    state = {
        haibaoImg: '',
        isShow: false,
    };

    haibaoRef = React.createRef();
    bodyDom = document.querySelector('body');

    handleScreen = async () => {
        let html2canvas = await import('html2canvas');
        const el = this.haibaoRef.current;

        html2canvas = html2canvas.default;
        html2canvas(el, {
            useCORS: true,
            width: el.offsetWidth,
            height: el.offsetHeight,
            scrollX: 0,
            scrollY: 0,
            scale: 4,
        }).then(canvas => {
            const context = canvas.getContext('2d');

            context.mozImageSmoothingEnabled = false;
            context.webkitImageSmoothingEnabled = false;
            context.msImageSmoothingEnabled = false;
            context.imageSmoothingEnabled = false;

            this.setState({
                haibaoImg: canvas.toDataURL(),
                isShow: true,
            });

            this.bodyDom.style.overflow = 'hidden';
            this.bodyDom.style.position = 'fixed';
        });
    };

    closeHanle = () => {
        this.setState({
            isShow: false,
        });

        this.bodyDom.style.overflow = '';
        this.bodyDom.style.position = '';
    };

    render() {
        const { haibaoImg, isShow } = this.state;
        const { bref, tip, allList = [] } = this.props;
        const extraData =
            (window.allData && window.allData.customization && window.allData.customization.extraData) || {};
        const shareIconColor = extraData.shareIconColor || '48,145,245';
        const qrcodeType = extraData.qrcodeType || 1;
        const qrcodeText = extraData.qrcodeText || '企业驰援河南捐款榜';

        return (
            <Fragment>
                <div
                    className={styles.shareBox}
                    style={{
                        backgroundColor: `rgb(${shareIconColor})`,
                        boxShadow: ` 0px 4px 8px 0px rgba(${shareIconColor}, 0.2)`,
                    }}
                    onClick={this.handleScreen}>
                    <div className={styles.shareTitle}>分享捐赠表</div>
                    <div className={styles.shareBref}>企业驰援河南捐款榜</div>
                </div>
                {isShow && (
                    <div className={styles.haibaoShadow}>
                        <div className={styles.haibaoShadowBox}>
                            <img className={styles.haibaoShadowPic} src={haibaoImg} />
                        </div>
                        <div className={styles.haibaoShadowText}>长按图片保存到手机</div>
                        <div className={styles.haibaoShadowClose} onClick={this.closeHanle} />
                    </div>
                )}
                <div className={styles.haibaoBox} ref={this.haibaoRef}>
                    <img
                        className={styles.haibaoBanner}
                        src="https://x0.ifengimg.com/ucms/2021_30/09CDAF774A0F2BB348A3102BF59BE76CB84011D1_size324_w750_h378.png"
                        alt=""
                    />
                    <div className={`${styles.searchBox}`}>
                        <div className={styles.search}>
                            <input type="text" readOnly="readonly" placeholder="搜索捐赠企业" />
                        </div>
                        <div className={styles.searchIcon}>搜索</div>
                    </div>
                    <div className={styles.searchBref}>
                        <div className={styles.banner}>{bref}</div>
                        <div className={styles.tip}>{tip}</div>
                    </div>
                    <div className={styles.tableList}>
                        <div className={styles.tableHead}>
                            <div className={styles.tableTd1}>企业名称</div>
                            <div className={styles.tableTd2}>捐款数据及物资等</div>
                        </div>
                        <div className={styles.tableBody}>
                            {allList.map((item, index) => {
                                return (
                                    <div className={styles.tableTr} key={index}>
                                        <div className={styles.tableTd1}>
                                            <div className={styles.company}>{item.company || ''}</div>
                                            <div className={styles.companyType}>
                                                {item.type ? `（${item.type}）` : ''}
                                            </div>
                                        </div>
                                        <div className={styles.tableTd2}>
                                            <div className={styles.contributionData}>{item.info || ''}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    {qrcodeType === 1 ? (
                        <div className={styles.qrcode}>
                            <div className={styles.qrcodeLeft}>
                                <img
                                    className={styles.qrcodeLogo}
                                    src="https://x0.ifengimg.com/ucms/2021_31/C55F12A1091FB55DA875A98573837A2F63B1761E_size16_w380_h72.png"
                                />
                            </div>
                            <div className={styles.qrcodeBox}>
                                <img
                                    className={styles.qrcodeImg}
                                    src="https://qrcode.ifeng.com/2021/07/27/732005dd2a6b3acc003236c16a19b001.png"
                                />
                                <div className={styles.qrcodeText}>扫码查看</div>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.qrcode1}>
                            <div className={styles.qrcode1Left}>
                                <img
                                    className={styles.qrcode1Logo}
                                    src="https://x0.ifengimg.com/ucms/2021_31/E0476AE83B7EB1F06252C902D8650757BFFF80C9_size12_w248_h52.png"
                                />
                            </div>
                            <div className={styles.qrcode1Center}>
                                <div className={styles.qrcode1CenterTitle}>
                                    长按识别二维码
                                    <img
                                        className={styles.qrcode1CenterIcon}
                                        src="https://x0.ifengimg.com/ucms/2021_31/5A49696701FF00E5E6384266AEC18E6037B23388_size0_w10_h14.png"
                                    />
                                </div>
                                <div className={styles.qrcode1CenterBref}>{qrcodeText}</div>
                            </div>
                            <div className={styles.qrcode1Box}>
                                <img
                                    className={styles.qrcode1Img}
                                    src="https://qrcode.ifeng.com/2021/07/27/732005dd2a6b3acc003236c16a19b001.png"
                                />
                            </div>
                        </div>
                    )}
                </div>
            </Fragment>
        );
    }
}

export default errorBoundary(Haibao);
